export const colWidths = [
    50,
    80,
    100,
    80,
    120,
    150,
    100,
    200,
    110
  ];
  